import { useRouter } from "vue-router";
import { handleBreadcrumbs } from "./middleware/breadcrumbs";
import { scrollToTop } from "@/shared/helpers/scrollToTop";

export default async (to) => {
    const currentRouteName = to.name;

    scrollToTop()

    handleBreadcrumbs('afterEach', to)

    if ( currentRouteName == "dashboard" || currentRouteName == "forum" ) return checkAndRedirectAfterLogin()
}



/**
 * Verifica e redireciona o usuário após o login, 
 * caso haja uma rota salva no sessionStorage (key = redirectAfterLogin).
 * @async
*/
const checkAndRedirectAfterLogin = async () => {
    const router = useRouter();

    const redirectData = sessionStorage.getItem("redirectAfterLogin");
    
    if ( !redirectData ) return;

    const { path, hash, params } = JSON.parse(redirectData);

    if ( !path ) {
        sessionStorage.removeItem("redirectAfterLogin");
        return;
    }

    try {

        /* Se houver apenas a rota ( sem hash e params ), redireciona para ela */
        if ( !hash && ( !params || Object.keys(params).length == 0 ) ) {
            await router.push(`/${path}`);

            sessionStorage.removeItem("redirectAfterLogin");

            return
        } 

        /* Se houver hash e/ou params, redireciona para a rota com os parâmetros e hash */
        await router.push({
            path: `/${path}`,
            query: {
                ...(hash && { hasTab: true }),
                ...(params && { hasParams: true })
            }
        });

    } catch (error) {
        console.error(`afterEach: Houve um erro ao redirecionar para a rota ${path}`, error)
    }
}